import React from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography, Paper } from '@mui/material';

function CameraView() {
  const { deviceId } = useParams();
  
  return (
    <Box>
      <Typography variant="h4" gutterBottom>Camera Stream</Typography>
      <Paper sx={{ p: 3 }}>
        <Typography>Device: {deviceId}</Typography>
        <Typography color="textSecondary">
          Live camera streaming interface will appear here.
        </Typography>
      </Paper>
    </Box>
  );
}

export default CameraView;
